module.exports = __webpack_public_path__ + "img/juxueIcon4.2fd94846.png";